import { useQuery } from "@tanstack/react-query";
import { fetchCategories, fetchCatalog } from "@/lib/api";

export const CATEGORIES_KEY = ["categories"];
export const CATALOG_KEY = ["catalog"];

export const useCategories = (options = {}) => {
    return useQuery({
        queryKey: CATEGORIES_KEY,
        queryFn: fetchCategories,
        ...options,
    });
};

export const useCatalog = (options = {}) => {
    return useQuery({
        queryKey: CATALOG_KEY,
        queryFn: fetchCatalog,
        ...options,
    });
};
